var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3 pt-4 lottery-page"},[_c('div',[_c('table',{staticClass:"col-12"},[_vm._m(0),_c('tbody',_vm._l((_vm.closedDayList),function(close,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(close.date))]),_c('td',[_vm._v(_vm._s(close.name))])])}),0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("Date")]),_c('th',[_vm._v("Name")])])])
}]

export { render, staticRenderFns }